/**
 * The `list_filter.sort_by` ListRoutes takes for each registry column, by column id. The
 * columns built from a route's first job (order, geozone, site, customer) read the job
 * the server returns first.
 */
export const ROUTE_SORT_FIELDS: Record<string, string> = {
  author: "author",
  route: "id",
  plate: "plate",
  driver: "driver",
  status: "status",
  created: "created_at",
  start: "fact_start_at",
  end: "fact_end_at",
  activeOrder: "first_job",
  geozone: "geozone",
  object: "pickup_location",
  service_receiver: "customer",
  pseudo: "pseudo",
};
